import styled from 'styled-components';

export const StyledTbmStatusInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 25px;
  }

  .component-body {
    padding: 0px 10px;
    gap: 7px;
    display: flex;
    flex-direction: column;
  }

  .item-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .item .item-label {
    width: 70px !important;
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
    /*word-break: break-all;*/
    white-space: nowrap;
    display: block !important;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .item .item-bar {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
  }

  .item .bar {
    width: 100%;
    background-color: #ededed;
    height: 13px;
    border-radius: 3px;
  }

  .item .item-bar .fill-bar {
    height: 13px;
    border-radius: 3px;
  }

  .item .empty-bar {
  }
`;
